/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Activity_ReviewInputs */



/**
* | output |
* | --- |
* | "Review" |
*
* @param {Assistant_Activity_ReviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_review = /** @type {((inputs?: Assistant_Activity_ReviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_ReviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Revoir")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rezension")
	if (locale === "it") return /** @type {LocalizedString} */ ("Revisione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обзор")
	if (locale === "es") return /** @type {LocalizedString} */ ("Revisar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("审查")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समीक्षा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Análise")
	return /** @type {LocalizedString} */ ("Review")
});